<template lang='pug'>
.classs-container(v-if='!bookMarksLoading')
    .swipe-wrap
        van-swipe.my-swipe(:autoplay='2000')
            van-swipe-item(
                v-for='(item, index) in data2',
                :key='index',
                @click='jump(item.link)'
            )
                img(v-src='item.img')
                .button-container
                    img(src='@/assets/imgs/回看@3x.png')
                    .looking {{ item.isReview ? "回看" : "预约" }}

    .tab-container
        van-tabs(v-model='active', @click='onClick')
            van-tab(v-for='(item, index) in kind', :key='index', :title='item')
                .content
                    .line
                .content-box
                    .yuyue-container(v-show='yuyue.length != 0')
                        .yuyue 预约推荐
                        template(v-for='(val, idx) in yuyue')
                            Class(
                                :key='val.id',
                                :time='val.time',
                                :title='val.title',
                                :link='val.link',
                                :img='val.img',
                                type='预约',
                                :desc='val.des',
                                cut='简介'
                            )
                    .huikan-container(v-show='huikan.length != 0')
                        .huikan 精彩回看
                        template(v-for='(value, i) in huikan')
                            Class(
                                :key='value.id',
                                :time='value.time',
                                :title='value.title',
                                :img='value.img',
                                type='回看',
                                cut='类型',
                                cutContent='视频回看',
                                :link='value.link',
                                v-if='value.status == "Enable"'
                            )

</van-swipe>
</template>

<script>
import { mapState } from 'vuex'
import Class from './components/class'
import { checkMember } from '@/service/member'
import { GetDataList } from "@/service/dataPool";
import { getDataHierarchies, getDataRows } from '@custouch/proxy-use'
import { getCmsStr } from './levelTitle'
export default {
    name: 'class',
    data() {
        return {
            active: 0,
            kind: [],
            yuyue: [],
            huikan: [],
            data2: [],
            data: []
        }
    },
    components: {
        Class
    },
    computed: {
        ...mapState(['memberInfo', 'bookMarks', 'bookMarksLoading'])
    },
    async created() {
        this.$root.$emit('action', { name: this.$route.name })
        const { module, template } = window.env.VITE_DATA
        const Hierarchies = await getDataHierarchies(module.liveClass)
        const dataHierarchyId = Hierarchies[0] ? Hierarchies[0].id : ''
        const { data } = await getDataRows({dataTemplateId:template.liveClass, dataHierarchyId, index: 1, size: 999,desc:true})
        const cms = getCmsStr({mId: this.$route.meta.mId,hId: dataHierarchyId})
        this.$root.$emit('pageview',{cms})
        data.map(item=>{
            this.data.push(Object.assign(item,item.detail))
        })
        // this.data = data.sort((a,b) => {
        //     return new Date(b.detail.time) - new Date(a.detail.time)
        // })
        this.data.forEach(val => {
            Object.assign(val, val.detail)
            this.kind.push(val.class)
        })
        this.kind = Array.from(new Set(this.kind))
        // bad?
        this.yuyue = this.data.filter(val => {
            return (val.class == this.kind[0]) && (val.isReview != "是")
        }).sort((a,b) => {
            return new Date(b.detail.time) - new Date(a.detail.time)
        })
        this.huikan = this.data.filter(val => {
            return (val.class == this.kind[0]) && (val.isReview == '是')
        }).sort((a,b) => {
            return new Date(b.detail.time) - new Date(a.detail.time)
        })
        this.data2 = this.data.reduce((pre, cur) => {
            if (cur.slideLInk) {
                pre.push({
                    img: cur.img,
                    link: cur.slideLInk,
                    isReview: cur.isReview == "是",
                    time: cur.time
                })
            }
            return pre
        }, []).sort((a,b)=>{return new Date(b.time) - new Date(a.time)}).sort((a, b) => a.isReview - b.isReview)

    },
    methods: {
        async jump(link) {
            const { VUE_APP_MEMBER_FORMID, VUE_APP_FORM } = window.env
            let isMember = await checkMember(true)
            if (isMember) {
                window.location.href = link
            } else {
                window.location.href = `${VUE_APP_FORM}${VUE_APP_MEMBER_FORMID}?redirect=${encodeURIComponent(window.location.href)}`
            }
        },
        onClick(name, title) {
            this.yuyue = this.data.filter(val => {
                return (val.class == title) && (val.isReview != "是")
            }).sort((a,b) => {
                return new Date(b.detail.time) - new Date(a.detail.time)
            })
            this.huikan = this.data.filter(val => {
                return (val.class == title) && (val.isReview == '是')
            }).sort((a,b) => {
                return new Date(b.detail.time) - new Date(a.detail.time)
            })
        }
    }
}
</script>

<style scoped lang='less'>
.line {
    position: absolute;
    width: 100%;
    height: 0.1rem;
    background: #f3f3f3;
    top: -0.1rem;
}

.content {
    position: relative;
}

.huikan {
    font-weight: 700;
}

/deep/ .van-tabs__wrap {
    padding-left: 1rem;
    padding-right: 1rem;
}

/deep/ .van-tab {
    flex: none;
    padding: 0;
}

/deep/ .van-tabs__nav {
    justify-content: space-between;
}

/deep/ .van-tabs__wrap {
    height: 1.5rem;
}

/deep/ .van-tabs__line {
    width: 2.55rem;
    height: 0.1rem;
    background: #07448a;
}

.classs-container {
    .content-box {
        padding: 1rem;

        .yuyue-container {
            padding-bottom: 0.2rem;

            .yuyue {
                color: #00448a;
                line-height: 0.9rem;
                margin-bottom: 0.6rem;
            }
        }

        .huikan-container {
            .huikan {
                color: #00448a;
                line-height: 0.9rem;
                margin-bottom: 0.6rem;
                font-weight: 700;
            }
        }
    }
}

.swipe-wrap {
    padding: 1rem;
    padding-bottom: 0.5rem;
    padding-top: 0;
}

.my-swipe {
    height: 8.15rem;
    border-radius: 0.3rem;

    img {
        height: 100%;
        width: 100%;
        display: block;
        object-fit: cover;
    }
}

/deep/ .van-swipe-item {
    position: relative;

    .button-container {
        height: 1rem;
        background: #219cdc;
        border-radius: 0.2rem;
        font-size: 0.55rem;
        position: absolute;
        bottom: 0.3rem;
        right: 0.5rem;
        display: flex;
        align-items: center;
        padding: 0 0.35rem;
        color: white;

        img {
            width: 0.4rem;
            height: 0.4rem;
            display: block;
            margin-right: 0.1rem;
        }
    }
}

/deep/ .van-swipe__indicators {
    left: 2.5rem;
    bottom: 0.4rem;
}

/deep/ .van-swipe__indicator {
    background: white;
    opacity: 1;
    width: 0.45rem;
    height: 0.45rem;
}

/deep/ .van-swipe__indicator--active {
    background: white;
    background: #219cdc;
    opacity: 1;
}

/deep/ .van-tab--active {
    color: #07448a;
}
</style>
